import React from 'react'
import PropTypes from 'prop-types'

import {
  SvgIcon,
  NavLink,
  ListItem,
  List as EventDetailsList
} from '../../components'

export const ActivityEventItem = ({ details, label, value, title, href, description }) => {
  let detailItems = []
  let keys = Object.keys(details)
  keys.forEach((key, index) => {
    detailItems.push(
      <ListItem
        className='slds-m-right_large'
        key={`activity_event_details_${title}_${index}`}>
        <div>
          <span className='slds-text-title'>{key}</span>
          <span className='slds-text-body_small slds-m-left_x-small'>
            {details[key]}
          </span>
        </div>
      </ListItem>
    )
  })

  return (
    <li>
      <span className='slds-assistive-text'>Item</span>
      <div className='slds-media'>
        <div className='slds-timeline slds-timeline__media slds-timeline__media--event'>
          <div className='slds-media__figure slds-timeline__icon'>
            <SvgIcon
              variant='utility'
              symbol='opened_folder'
              size='small'
              colour='light'
            />
          </div>
          <div>
            <h3 className='slds-truncate' title={title}>
              <NavLink to={href} >
                {title}
              </NavLink>
            </h3>
            {description && <p className='slds-truncate'>{description}</p>}
            <EventDetailsList items={detailItems} type='slds-list--vertical slds-wrap' />
          </div>
        </div>
      </div>
    </li>
  )
}

ActivityEventItem.props = {
  details: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  description: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/activity-event-item/index.js